import { Col, ModalBody, ModalFooter, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import CheckboxField from 'components/forms/checkboxField/CheckboxField';
import FormWithProvider from 'components/forms/form/Form';
import FormFieldset from 'components/forms/form/FormFieldset';
import TextField from 'components/forms/textField/TextField';
import ModalFormCancelButton from 'components/modal/form/ModalFormCancelButton';
import ModalFormSubmitButton from 'components/modal/form/ModalFormSubmitButton';
import useModalId from 'components/modal/useModalId';
import useAppModal from 'hooks/useAppModal';
import {
  EditLinkPluginModalFormValues,
  editLinkPluginModalSchema,
} from './EditLinkPluginModal.schema';

interface EditLinkPluginModalProps {
  defaultValues: EditLinkPluginModalFormValues;
  onSubmit: (args: EditLinkPluginModalFormValues) => void;
}

const EditLinkPluginModal = ({
  defaultValues,
  onSubmit,
}: EditLinkPluginModalProps) => {
  const { t } = useTranslation();
  const modalId = useModalId();
  const { closeModal } = useAppModal();

  const handleOnSubmit = (values: EditLinkPluginModalFormValues) => {
    closeModal(modalId);
    onSubmit(values);
  };

  return (
    <FormWithProvider
      defaultValues={defaultValues}
      onSubmit={handleOnSubmit}
      resolver={editLinkPluginModalSchema(t)}
      noValidate
    >
      <FormFieldset>
        <ModalBody>
          <Row className="d-flex flex-column">
            <TextField
              colSmInput={12}
              label={t('form.editor.link.text')}
              labelOnTop
              name="text"
              required
            />
            <TextField
              colSmInput={12}
              label={t('form.editor.link.url')}
              labelOnTop
              name="url"
              required
            />
          </Row>
          <Row>
            <Col sm={12}>
              <CheckboxField name="openInNewWindow">
                {t('form.editor.link.openInNewWindow')}
              </CheckboxField>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <ModalFormCancelButton />
          <ModalFormSubmitButton />
        </ModalFooter>
      </FormFieldset>
    </FormWithProvider>
  );
};

export default EditLinkPluginModal;
